import { sfx } from "../lib/soundEngine";

export const Hero = () => {
    const scrollToGames = () => {
        sfx.coin();
        const el = document.getElementById("games");
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <section className="relative overflow-hidden">
            <div className="max-w-7xl mx-auto px-5 md:px-8 pt-16 pb-20 md:pt-24 md:pb-28">
                <div className="max-w-4xl">
                    <p
                        data-testid="hero-insert-coin"
                        className="font-pixel text-2xl md:text-3xl neon-amber mb-4"
                    >
                        ▸ INSERT COIN <span className="blink neon-amber">_</span>
                    </p>
                    <h1
                        data-testid="hero-title"
                        className="font-pixel neon-cyan leading-none"
                        style={{ fontSize: "clamp(4.5rem, 12vw, 10rem)" }}
                    >
                        METE&apos;S SITE
                    </h1>
                    <p
                        data-testid="hero-subheading"
                        className="mt-6 md:mt-8 text-base md:text-lg text-gray-300 font-body max-w-2xl leading-relaxed"
                    >
                        A dark-mode retro cyber-arcade. Four classic mini-games,
                        wired straight into your browser. No downloads, no lag —
                        just neon glow, pixel dust, and highscores waiting to be
                        beaten. Press play and roll the credits.
                    </p>

                    <div className="mt-10 flex flex-wrap items-center gap-4">
                        <button
                            onClick={scrollToGames}
                            data-testid="hero-play-now-btn"
                            className="btn-neon"
                        >
                            <i className="fa-solid fa-play" />
                            Play Now
                        </button>
                        <div className="flex items-center gap-3 text-sm font-pixel text-gray-400">
                            <span className="w-2 h-2 rounded-full inline-block" style={{ background: "var(--neon-lime)", boxShadow: "0 0 8px var(--neon-lime)" }} />
                            4 CABINETS ONLINE
                        </div>
                    </div>
                </div>
            </div>

            {/* Decorative grid backdrop */}
            <div
                aria-hidden="true"
                className="pointer-events-none absolute inset-x-0 bottom-0 h-40 opacity-40"
                style={{
                    background:
                        "linear-gradient(to bottom, transparent, rgba(43, 27, 84, 0.5))," +
                        " repeating-linear-gradient(90deg, rgba(0, 240, 255, 0.12) 0 1px, transparent 1px 60px)," +
                        " repeating-linear-gradient(0deg, rgba(0, 240, 255, 0.12) 0 1px, transparent 1px 60px)",
                }}
            />
        </section>
    );
};
